export const prefix = '@@redux-modal/'

export const OPEN = `${prefix}OPEN`
export const CLOSE = `${prefix}CLOSE`
export const INITIALIZE = `${prefix}INITIALIZE`
export const DESTROY = `${prefix}DESTROY`
